
<div class="pointer product-item padding-10 product-elevat ext-center" *ngIf="bloglayouttype === 0">
  <div fxLayout="row" class="" fxLayoutAlign="center center">
    <img loading="lazy"
    [alt]="name"
    (click)="goToBlogData()"
    [src]="image"
    [style.height]="height"
    [style.width]="width"
    [ngStyle.lt-md]="{'height': heightMobile, 'width': widthMobile}"
    onerror="this.src='assets/images/products/noImage/no-image.png';" />

  </div>
  <div class="productPrice padding-rl10" fxLayout="row" [style.height]="data.blogOverallHeight"
    [ngStyle.lt-md]="{ 'height': blogOverallHeightMob}" fxLayoutAlign="center center">

    <div fxFlex="100" class="f16 text123444" style="cursor: pointer;" (click)="goToBlogData()">
      <b class="modernWay1" [style.-webkit-line-clamp]="blogNameDisplayLine" [style.line-clamp]="blogNameDisplayLine"
        [ngStyle.lt-md]="{ '-webkit-line-clamp': blogNameDisplayLineMob, 'line-clamp': blogNameDisplayLineMob }">{{blog.title}}</b>
    </div>


  </div>

  <div class="productPrice padding-rl10" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" style="cursor: pointer;" (click)="goToBlogData()">
      <b class="modernWay1" [style.-webkit-line-clamp]="blogNameDisplayLine" [style.line-clamp]="blogNameDisplayLine"
        [ngStyle.lt-md]="{ '-webkit-line-clamp': blogNameDisplayLineMob, 'line-clamp': blogNameDisplayLineMob }">
        {{blog.rootTemplate}}</b>
    </div>
  </div>


  <div fxLayout="row" class="padding-10 ">
    <div fxFlex="100" class="description" style="cursor: pointer;" (click)="goToBlogData()">
      <b class="modernWay1" [style.-webkit-line-clamp]="blogNameDisplayLine" [style.line-clamp]="blogNameDisplayLine"
        [ngStyle.lt-md]="{ '-webkit-line-clamp': blogNameDisplayLineMob, 'line-clamp': blogNameDisplayLineMob }">{{blog.metaDescription}}</b>
    </div>
  </div>

  <div fxLayout="row" class="padding-10">
    <button class="primary" fxFlex (click)="goToBlogData()" style="color: white" mat-flat-button>
      <span>Read More</span>
    </button>
  </div>


</div>
<div class="blog-container" fxLayout="column" fxLayoutAlign="start center" *ngIf="bloglayouttype === 1">
  <div class="blog-image" fxFlex="none">
    <img loading="lazy"
    class="responsive-img"
    [alt]="name"
    (click)="goToBlogData()"
    [src]="image"
    [ngStyle.lt-md]="{'height': heightMobile, 'width': widthMobile}"
    onerror="this.src='assets/images/products/noImage/no-image.png';" />

  </div>

  <div class="blog-content" fxFlex="60" fxLayout="column">
    <p class="author">
      <!-- <strong>Shuvra Saha</strong> | February 4, 2025 | 4 min read -->
    </p>
    <h2 class="title-new" (click)="goToBlogData()">{{blog.title}}</h2>
    <p class="description-new" (click)="goToBlogData()">
      {{blog.metaDescription}}
    </p>
  </div>
</div>

